import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ym, ym_1, ym_2 } from '../../lib/dayUtil'
import FullPageBase from '../layouts/FullPageBase'
import BlockTitle from '../blocks/BlockTitle'
import SectionPreloader from '../common/SectionPreloader'
import { ParentSize } from '@visx/responsive'
import EventList from '../common/callist/EventList'
import { tagFilter, tagFilterAry } from '../../lib/listUtil'
import MyMonthPicker from '../common/atom/MyMonthPicker'
import { useNavigate } from 'react-router-dom'

function StoreNewsPage({group, sub}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {newses, tousens, dbCalling} = useSelector((state) => state);
  const [sortedEvents, setSortedEvents] = useState(null);
  const date = ym(new Date());
  const date_1 = ym_1(new Date());
  const date_2 = ym_2(new Date());
  useEffect(()=> {
    if(!date) return;
    let length= 0;
    if(newses[date] && sub){
      length += tagFilterAry(sub, newses[date]).length || 0;
      length += tagFilterAry(sub, newses[date_1]).length || 0;
      length += tagFilterAry(sub, newses[date_2]).length || 0;
    }
    if(!newses[date] || length < 3) {
      dispatch({type:'SAGA_BY_NEWS_3MONTH', payload:{query_type:"news_by_date", filter:sub, eventDates:[date, date_1, date_2]}});
    }
  }, [date, sub])

  useEffect(()=> {
    if(!newses) return;
    let items = newses;
    if(sub) items = tagFilter(sub, items);
    setSortedEvents(items);

  }, [tousens, group, sub, dbCalling, date, newses])


  const changeDate=(date)=> {
    const url_ = sub ? `/news?yearmonth=${date}&sub=${sub}` : `/news?yearmonth=${date}`;
    navigate(url_);
  }

  return (
    <FullPageBase title={`${group} | TOWER RECORDS SHIBUYA`} item={{type:'top'}} top={!!newses} dbCalling={dbCalling}>
        <section className="top-block rounded-box news">
          <div className="flex justify-between items-center flex-wrap">
            <BlockTitle title={group} type="top" sub={sub}/>
           <MyMonthPicker searchDate={date} setSearchDate={(val)=> changeDate(ym(val))}/>
          </div>
          <div className="absolute w-full h-full top left flex justify-center items-center pointer-events-none select-none">
            <SectionPreloader show={dbCalling} />
          </div>



          <div className="relative">
            <ParentSize>
              {
                ({ width }) =>  <div className="event_block">
                <EventList type="news" date={date} events={sortedEvents}  />
                  <EventList type="news" date={date_1}  events={sortedEvents}  />
                  <EventList type="news" date={date_2}  events={sortedEvents}  />
                </div>
              }
            </ParentSize>
          </div>
        </section>
      </FullPageBase>
  )
}

export default StoreNewsPage;
